import { jsonp, ajax } from '@ifeng/ui_base';
import { userkeyUtil } from '@ifeng/three_terminal/es/utils/h5PageCount';
import { getQueryString } from '@ifeng/container_channel/common/client/utils/utils';

const getHotNewsApiParams = () => {
    const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;
    const proid = isVideoShare ? 'ifengvideoh5' : 'ifengnewsh5';
    let defaultParams = `?page=1&gv=7.9.1&av=7.9.1&uid=${userkeyUtil.init()}&deviceid=ee988cd23e3159dc&proid=${proid}&os=android_29&df=androidphone&vt=5&screen=1080x1794&publishid=develop&nw=wifi&st=15712118293739&sn=0a19d617448ff2f0bd9df7497f80a4e3&dlt=40.011686&dln=116.497205&dcy=%25E5%258C%2597%25E4%25BA%25AC%25E5%25B8%2582&dpr=%25E5%258C%2597%25E4%25BA%25AC%25E5%25B8%2582&skinid=default&isnoad=1&nosign=1`;

    if (typeof window !== 'undefined' && window.grounds) {
        defaultParams = `?page=1&gv=${window.grounds
            .getDeviceInfo()
            .getGv()}&av=0&proid=${proid}&os=${window.grounds
            .getDeviceInfo()
            .getOs()}&df=${window.grounds
            .getDeviceInfo()
            .getDf()}%2C1&vt=5&screen=828x1792&publishid=${window.grounds
            .getDeviceInfo()
            .getPublishid()}&uid=${window.grounds
            .getUserInfo()
            .getGuid()}&nw=wifi&loginid=97018491&token=15060E2D7D8F261119703DA9A9D0B3B6&st=15928198389778&sn=241ad569d60b7b0918d2f53024e904b9`;
    }

    const search = defaultParams.replace('?', '').split('&');
    const params = {};

    search.forEach(item => {
        const data = item.split('=');

        params[data[0]] = data[1];
    });

    return params;
};

const formatHotNewsData = (listData, callUp) => {
    let isIOS = typeof window !== 'undefined' && /AppleWebKit/i.test(navigator.userAgent);
    const typesMap = {
        short: 'shortCustom',
        doc: 'article',
        phvideo: 'video',
        topic2: 'topic',
    };

    const formatImg = item => {
        if (isIOS && item) {
            let urlFilter = item.replace(/_webp/g, '');

            urlFilter = urlFilter.replace(/png\.webp/g, 'png');
            urlFilter = urlFilter.replace(/jpg\.webp/g, 'jpg');
            urlFilter = urlFilter.replace(/gif\.webp/g, 'gif');

            return urlFilter;
        }

        return item;
    };

    return listData.map((item, index) => {
        return {
            ...item,
            noTopLine: index === 0 && item.type === 'short',
            thumbnail: item.thumbnail,
            source: item.subscribe?.catename || item.source,
            commentUrl: item.commentsUrl,
            base62Id: item.id.replace('ucms_', ''),
            summary: item.summary || item.intro,
            callUp,
            newStyle: item.style.view,
            newstype: item.type,
            videoPlayUrl: item.link.mp4,
            thumbnails: {
                image:
                    item.type !== 'short'
                        ? item.style.images?.map(item => ({ url: item })) || [{ url: '' }]
                        : item.style.imageList?.map(item => ({ url: item.url })) || [{ url: '' }],
            },
            url: callUp ? item.link.url : item.link.weburl,
            clickCount: {
                behavior: 'action',
                type: 'openNewsapp',
                other: {
                    ref: `${item.id}`,
                    kind: 'article',
                },
            },
            downloads: {
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
            },
            type: typesMap[item.type] || item.type,
            duration: item.phvideo && item.phvideo.length,
            newsTime: item.updateTime || '',
        };
    });
};

// 热点聚焦分享页
const getHotNewsData = async ({ page, PAGE_INFO }) => {
    const params = getHotNewsApiParams();

    const res = await jsonp(PAGE_INFO.api, {
        type: PAGE_INFO.method,
        data: Object.assign(params, {
            page,
            isnoad: 1, // 滤除广告
            ...PAGE_INFO.params,
        }),
        cache: false,
        jsonpCallback: 'getHotNewsDataCallback',
    });

    if (res?.data?.list && !PAGE_INFO.noFormatData) res.data.list = formatHotNewsData(res.data.list, undefined);

    return res;
};

const getSingleNewsData = async ({ PAGE_INFO }) => {
    const params = getHotNewsApiParams();

    const res = await jsonp(PAGE_INFO.api, {
        type: PAGE_INFO.method,
        data: Object.assign(params, {
            isnoad: 1, // 滤除广告
            ...PAGE_INFO.params,
        }),
        cache: false,
        jsonpCallback: 'getHotNewsDataCallback',
    });

    return res;
};

const getHotEventsData = async (id, page) => {
    const step = 15;
    const start = step * (page - 1);
    const res = await jsonp(`https://shankapi.ifeng.com/feedflow/hotEvents/${id}/${start}/${step}/callback`, {
        jsonpCallback: 'callback',
    });

    return res;
};

export { getHotNewsData, getSingleNewsData, getQueryString, formatHotNewsData, getHotEventsData };
